import React, { useState, useEffect } from 'react'

import './ImagePreview.scss'

export const ImagePreview = ({
  id,
  file,
  url,
  name = 'Receipt Image',
  uploadProgress = 100,
  onRemoveImage = () => {},
}) => {
  let defaultImg =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAADElEQVQImWP4//8/AAX+Av5Y8msOAAAAAElFTkSuQmCC'
  const [imageUrl, setImageUrl] = useState(defaultImg)

  const getBase64 = file => {
    try {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        setImageUrl(reader.result)
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    file && getBase64(file)
  }, [file, getBase64])

  const progressStyle = {
    width: `${uploadProgress}%`,
  }

  return (
    <>
      <li
        className={`image-preview`}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        <div className={`uploaded-image-item-info`}>
          {id && (
            <div
              onClick={() => {
                onRemoveImage(id)
              }}
              className={`uploaded-image-remove x-button`}
            ></div>
          )}

          {uploadProgress && uploadProgress < 100 && (
            <div className={`uploaded-image-item-uploadbar`}>
              <div
                className={`uploaded-image-item-uploadbar-progress`}
                style={progressStyle}
              ></div>
            </div>
          )}
          <div className={`uploaded-image-item-name`}>{name}</div>
        </div>
      </li>
    </>
  )
}

export default ImagePreview
